<tec-tabs [tabs]="tabs"></tec-tabs>
<!-- TAB: OPERACIONES -->
@if (tabs.length && tabs[0].selected) {
<div class="collapse-group">
    <tec-collapse [title]="'WORKFLOWS.FORM.GENERAL.DETAIL' | translate" [icon]="'icon-capture-popup'">
        @if (canViewDeveloperCurl()) {
            <tec-button-icon
                icon="icon-code-brackets"
                type="default"
                size="sm"
                (clickEvent)="openCurlModal('WORKFLOWS.CURL_MODAL.TITLE_SECTION_DETAILS', sectionCurlPath('details'))"
            />
        }
        <div class="grid grid-i2">
            <!-- ALIAS -->
            <tec-info-group [label]="'WORKFLOWS.FORM.GENERAL.NAME' | translate">
                <span>{{ detail?.alias }}</span>
            </tec-info-group>
            <!-- CONFIG.VALIDATION -->
            <tec-info-group [label]="'WORKFLOWS.FORM.GENERAL.VALIDATION_TYPE' | translate">
                <tec-tag
                    [label]="('WORKFLOWS.FORM.GENERAL.VALIDATION_TYPE_OPT.' + getValidationTypeOpt(detail)) | translate"
                />
            </tec-info-group>
            <!-- DATE_CREATE -->
            <tec-info-group [label]="'WORKFLOWS.DETAIL.DATE_CREATE' | translate">
                <tec-icon name="icon-calendar" size="xs" />
                <span>{{ detail?.created_at | date : 'dd/MM/yyyy - HH:mm' }}</span>
            </tec-info-group>

            <!-- COMPANY_NAME -->
            <tec-info-group [label]="'WORKFLOWS.FORM.GENERAL.COMPANY' | translate">
                <span>{{ detail?.company_name }}</span>
            </tec-info-group>
            <!-- API_KEY -->
            <tec-info-group class="info-group-uuid" [label]="'WORKFLOWS.FORM.GENERAL.APIKEY' | translate">
                <app-uuid-display [uuid]="detail?.api_key" />
            </tec-info-group>
        </div>
    </tec-collapse>

    <tec-collapse [title]="'WORKFLOWS.FORM.GENERAL.GET_DATA' | translate" [icon]="'icon-file'">
        @if (canViewDeveloperCurl()) {
            <tec-button-icon
                icon="icon-code-brackets"
                type="default"
                size="sm"
                (clickEvent)="openCurlModal('WORKFLOWS.CURL_MODAL.TITLE_SECTION_DATA_COLLECTION', sectionCurlPath('data-collection'))"
            />
        }
        <div class="grid grid-i2">
            <!-- CONFIG.LOCATION -->
            <tec-info-group [label]="'WORKFLOWS.FORM.GENERAL.LOCATION' | translate">
                <tec-tag
                    [status]="getStatus(detail?.config?.location !== 'disabled')"
                    [label]="`WORKFLOWS.FORM.GENERAL.LOCATION_OPT.${detail?.config?.location?.toUpperCase()}` | translate"
                />
            </tec-info-group>
            <!-- CONFIG.REQUIRED_RECORDING -->
            <tec-info-group [label]="'WORKFLOWS.FORM.GENERAL.REQUIRED_RECORDING' | translate">
                <tec-tag
                    [status]="getStatus(detail?.config?.required_recording)"
                    [label]="getStatusLabel(detail?.config?.required_recording)"
                />
            </tec-info-group>

            <!-- CONFIG.INCLUDE_IMAGES -->
            <tec-info-group [label]="'WORKFLOWS.FORM.GENERAL.INCLUDE_IMAGES' | translate">
                <tec-tag
                    [status]="getStatus(detail?.config?.include_images)"
                    [label]="getStatusLabel(detail?.config?.include_images)"
                />
            </tec-info-group>
        </div>
    </tec-collapse>

    <tec-collapse [title]="'WORKFLOWS.FORM.GENERAL.ACCESS' | translate" [icon]="'icon-open-web'">
        @if (canViewDeveloperCurl()) {
            <tec-button-icon
                icon="icon-code-brackets"
                type="default"
                size="sm"
                (clickEvent)="openCurlModal('WORKFLOWS.CURL_MODAL.TITLE_SECTION_ACCESS', sectionCurlPath('access'))"
            />
        }
        <div class="grid grid-i2">
            <!-- CONFIG.ALLOWED_DEVICE -->
            <tec-info-group [label]="'WORKFLOWS.DETAIL.ALLOWED_DEVICE' | translate">
                <tec-tag-group [tags]="allowedDeviceTags" />
            </tec-info-group>
            <!-- CONFIG.HAS_SAVED_STATE -->
            <tec-info-group [label]="'WORKFLOWS.DETAIL.HAS_SAVED_STATE' | translate">
                <tec-tag
                    [label]="`BUTTON.${detail?.config?.has_saved_state ? 'CONTINUE' : 'RESET'}` | translate"
                    [tooltip]="`WORKFLOWS.FORM.GENERAL.HAS_SAVED_STATE_${detail?.config?.has_saved_state ? 'CONTINUE' : 'RESET'}_TOOLTIP` | translate"
                />
            </tec-info-group>

            <!-- CONFIG.SDK -->
            <tec-info-group [label]="'WORKFLOWS.FORM.GENERAL.SDK' | translate">
                <tec-tag [status]="getStatus(detail?.config?.sdk)" [label]="getStatusLabel(detail?.config?.sdk)" />
            </tec-info-group>
            <!-- CONFIG. -->
            <tec-info-group
                [label]="'WORKFLOWS.DETAIL.ALERT_POSTERGADO' | translate"
                [tooltip]="'WORKFLOWS.FORM.GENERAL.ALERT_POSTERGADO_DESCRIPTION' | translate"
            >
                <tec-tag
                    [status]="getStatus(detail?.config?.delayed_process_warning)"
                    [label]="getStatusLabel(detail?.config?.delayed_process_warning)"
                />
                @if (detail?.config?.delayed_process_warning) {
                    <tec-link
                        [label]="'WORKFLOWS.DETAIL.ALERT_POSTERGADO_VIEW' | translate"
                        (click)="showDelayedProcessTextModal = true"
                    />
                }
            </tec-info-group>
            <tec-modal
                [isVisible]="showDelayedProcessTextModal"
                [title]="'WORKFLOWS.DETAIL.ALERT_POSTERGADO' | translate"
                (closeEvent)="showDelayedProcessTextModal = false"
            >
                <app-text-locale-preview [textLocale]="detail?.config?.delayed_process_warning_text" />
            </tec-modal>
            @if (hasWorkflowTwoFactorEnabled()) {
                <tec-info-group [label]="'WORKFLOWS.FORM.GENERAL.TWO_FACTOR_AUTH' | translate">
                    <tec-tag [label]="getWorkflowTwoFactorLabel()" />
                </tec-info-group>
            }
        </div>
    </tec-collapse>

    <tec-collapse [title]="'WORKFLOWS.FORM.GENERAL.ANTIFRAUDE_GENERAL' | translate" [icon]="'icon-shield'">
        @if (canViewDeveloperCurl()) {
            <tec-button-icon
                icon="icon-code-brackets"
                type="default"
                size="sm"
                (clickEvent)="openCurlModal('WORKFLOWS.CURL_MODAL.TITLE_SECTION_ANTIFRAUD', sectionCurlPath('antifraud'))"
            />
        }
        <div class="item-group">
            <!-- CONFIG.ANTIFRAUD.BLOCK_OPERATION -->
            <tec-item
                [tagImage]="{ icon: 'icon-x-circle', status: 'notice' }"
                [title]="'WORKFLOWS.FORM.GENERAL.BLOCK_OPERATION' | translate"
            >
                <tec-list-detail>
                    <tec-tag
                        [status]="getStatus(detail?.config?.antifraud?.block_operation)"
                        [label]="getStatusLabel(detail?.config?.antifraud?.block_operation)"
                    />
                </tec-list-detail>
            </tec-item>

            <!-- CONFIG.ANTIFRAUD.EMAIL_ALERT -->
            <tec-item
                [tagImage]="{ icon: 'icon-mail', status: 'notice' }"
                [title]="'WORKFLOWS.FORM.GENERAL.EMAIL_ALERT' | translate"
                [collapse]="!!detail?.config?.antifraud?.email_alert"
            >
                <tec-list-detail>
                    <tec-tag
                        [status]="getStatus(!!detail?.config?.antifraud?.email_alert)"
                        [label]="getStatusLabel(!!detail?.config?.antifraud?.email_alert)"
                    />
                </tec-list-detail>

                <span>{{ detail?.config?.antifraud?.email_alert }}</span>
            </tec-item>
        </div>

        <!-- CONFIG.ANTIFRAUD -->
        <tec-tile
            [title]="'WORKFLOWS.DETAIL.ANTIFRAUDE_GENERAL_WORKFLOW' | translate"
            [subtitle]="'WORKFLOWS.DETAIL.ANTIFRAUDE_GENERAL_WORKFLOW_DESCRIPTION' | translate"
        >
            <div class="grid grid-i3">
                <!-- CONFIG.ANTIFRAUD.IP_BLOCK -->
                <tec-info-group [label]="'WORKFLOWS.FORM.GENERAL.IP' | translate">
                    <tec-tag
                        [status]="getStatus(detail?.config?.antifraud?.ip_block)"
                        [label]="getStatusLabel(detail?.config?.antifraud?.ip_block)"
                    />
                </tec-info-group>
                <!-- CONFIG.ANTIFRAUD.IDENTIFIER_BLOCK -->
                <tec-info-group [label]="'WORKFLOWS.FORM.GENERAL.IDENTIFIER_BLOCK' | translate">
                    <tec-tag
                        [status]="getStatus(detail?.config?.antifraud?.identifier_block)"
                        [label]="getStatusLabel(detail?.config?.antifraud?.identifier_block)"
                    />
                </tec-info-group>
                <!-- CONFIG.ANTIFRAUD.FACE_BLOCK -->
                <tec-info-group [label]="'WORKFLOWS.FORM.GENERAL.FACE' | translate">
                    <tec-tag
                        [status]="getStatus(detail?.config?.antifraud?.face_block)"
                        [label]="getStatusLabel(detail?.config?.antifraud?.face_block)"
                    />
                </tec-info-group>
            </div>
        </tec-tile>
    </tec-collapse>
</div>
} @else if (tabs.length && tabs[1].selected){
<div class="collapse-group">
    @for (item of detail?.operations; track $index) {
        @if (item.type === OPERATION_TYPE.HOME) {
            <app-home-operation [operation]="$any(item)" [index]="$index + 1" [profileUuid]="detail?.uuid" />
        }
        @if (item.type === OPERATION_TYPE.OCR) {
            <app-ocr-operation [operation]="$any(item)" [index]="$index + 1" [profileUuid]="detail?.uuid" />
        }
        @if (item.type === OPERATION_TYPE.POL) {
            <app-pol-operation [operation]="$any(item)" [index]="$index + 1" [profileUuid]="detail?.uuid" />
        }
        @if ((item.type === OPERATION_TYPE.DOCUMENTS && hasAttorneyPowersLikeDocs()) ||
            item.type === OPERATION_TYPE.CONNECTIONS && item.config?.type === CONNECTION_TYPE.SCRIPTURE) {
            <app-attorney-powers-operation [operation]="$any(item)" [index]="$index + 1" [profileUuid]="detail?.uuid" />
        }
        @if (
            (item.type === OPERATION_TYPE.DOCUMENTS && !hasAttorneyPowersLikeDocs()) ||
            (item.type === OPERATION_TYPE.CONNECTIONS && !item.config?.evaluation && hasConnecLikeDocAndNotDocsOperation())
        ) {
            <app-docs-operation [operation]="$any(item)" [operations]="detail.operations" [index]="$index + 1" [profileUuid]="detail?.uuid" />
        }
        @if (item.type === OPERATION_TYPE.CHOOSE) {
            <app-choose-operation [operation]="$any(item)" [index]="$index + 1" [profileUuid]="detail?.uuid" />
        }
        @if (item.type === OPERATION_TYPE.FORM) {
            <app-form-operation [operation]="$any(item)" [index]="$index + 1" [profileUuid]="detail?.uuid" />
        }
        @if (item.type === OPERATION_TYPE.CONNECTIONS && item.config?.type !== CONNECTION_TYPE.SCRIPTURE && item.config?.evaluation) {
            <app-financial-evaluation-operation [operation]="$any(item)" [index]="$index + (hasConnecLikeDocAndDocsOperation() ? 0 : 1)" [profileUuid]="detail?.uuid" />
        }
        @if (item.type === OPERATION_TYPE.FINISH) {
            <app-finish-operation [operation]="$any(item)" [index]="$index + (hasConnecLikeDocAndDocsOperation() ? 0 : 1)" [profileUuid]="detail?.uuid" />
        }
    }
</div>
}

@if (curlModalOpen()) {
<app-modal-curl-request
    [titleKey]="curlModalTitleKey()"
    [curlText]="curlModalText()"
    (closeEvent)="closeCurlModal()"
/>
}
